/* Appendix A and B — static reference tables, transcribed from the OIA audit
   report template (backend templates/oia_audit_report.html.j2, lines 277-370).
   They are boilerplate on both surfaces; if the PDF's copy ever changes, change
   it here too. Nothing derives from project data. */

export const APPENDIX_A_ROWS = [
  {
    rating: 'High',
    timeframe: 'Generally, Within 60 days',
    description:
      'Serious control weakness that could undermine the system of internal controls or the achievement of objectives within the business area or process being reviewed. And/or repeated medium risk observation for more than 2 years.',
  },
  {
    rating: 'Medium',
    timeframe: 'Generally, Within 120 days',
    description:
      'A control weakness that is unlikely to have a seriously adverse effect on the achievement of objectives of the business area or process but existing controls need improvement for effectiveness to enhance the controls environment.',
  },
  {
    rating: 'Low',
    timeframe: 'No indicative timing',
    description:
      "Represents an occasional lapse with minimal impact on the unit's processes.",
  },
  {
    rating: 'Recommendation',
    timeframe: 'No indicative timing',
    description: 'Opportunity for improvements.',
  },
] as const;

export const APPENDIX_B_ROWS = [
  { rating: 'Unacceptable risk exposure', high: '3 or more', medium: '9 or more' },
  { rating: 'Major Improvement Opportunity', high: '2', medium: '6 to 8' },
  { rating: 'Some Improvement Opportunity', high: '1', medium: 'Up to 5' },
  { rating: 'Satisfactory', high: '1', medium: 'Up to 3' },
  { rating: 'Well-Managed', high: '-', medium: '1' },
] as const;

export const APPENDIX_B_NOTES = [
  'High is equivalent to 3 Medium risk observations.',
  'Low risk observations are not considered in the overall rating.',
  'The audit report rating matrix above is only indicative. Based on the severity of control issues, underlying risks and root causes justifications, report rating may be varied against the number of issues reported.',
] as const;
